export default __webpack_public_path__ + "static/media/wordvoyage-logo.418d3efa.jpeg";